import { stripTags } from '@utils/jsonLd/text';

/**
 * Превращает HTML ответа FAQ в безопасный массив строк-абзацев для рендера в JSX.
 *
 * ПОЧЕМУ ТАК:
 * 1. Исключает `dangerouslySetInnerHTML` и связанные с ним XSS-векторы (<script>,
 *    <img onerror=...>, javascript: и т.д.) — React рендерит строки как textContent
 *    с автоматическим экранированием.
 * 2. Разделяет абзацы (<p>, <div>, <br>) на отдельные элементы <p>, сохраняя
 *    визуальную структуру ответа.
 * 3. Изоморфно работает на Node.js сервере (SSR) и клиенте без тяжелых внешних
 *    зависимостей вроде DOMPurify/JSDOM, исключая падения и hydration mismatch.
 */
export const toParagraphs = (html: string | null | undefined): string[] => {
  if (!html) {
    return [];
  }
  const withoutScripts = html
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '');
  const withLineBreaks = withoutScripts
    .replace(/<(br|hr)\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|ul|ol|h[1-6]|tr|td|th|blockquote|section)>/gi, '\n');
  return withLineBreaks
    .split('\n')
    .map(line => stripTags(line))
    .filter(Boolean);
};
